import { NgModule } from '@angular/core';
import { ActionButtonModule } from '../../ui-kit/action-button/action-button.module';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { ProfilesDialogComponent } from './profiles-dialog.component';
import { ListFilterModule } from '../../ui-kit/list-filter';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ProfilesDialogComponent],
  imports: [IntrackFeatureModule, ActionButtonModule, ListFilterModule, TranslateModule.forChild({})],
  exports: [ProfilesDialogComponent],
})
export class ProfilesDialogModule {}
